import { ComponentType, ReactNode } from "react";

interface CreateSectionCardProps {
  /** Ancre de navigation (menu latéral). */
  id: string;
  icon: ComponentType<{ className?: string }>;
  title: string;
  subtitle?: string;
  /** Action optionnelle alignée à droite du header (ex. bouton « Modifier »). */
  action?: ReactNode;
  children: ReactNode;
}

/**
 * Carte de section : icône dans un carré arrondi, titre + sous-titre, action
 * optionnelle à droite, séparateur, puis contenu. Sert d'ancre pour le menu
 * latéral (id + scroll-mt).
 */
export const CreateSectionCard: React.FC<CreateSectionCardProps> = ({
  id,
  icon: Icon,
  title,
  subtitle,
  action,
  children,
}) => (
  <div id={id} className="rounded-xl bg-section scroll-mt-6">
    <div className="flex items-center gap-3 px-6 pt-5 pb-4 border-b border-gray-200/70">
      <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
        <Icon className="w-5 h-5 text-primary" />
      </div>
      <div className="min-w-0 flex-grow">
        <p className="text-base font-bold text-content-dark">{title}</p>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
    <div className="p-6">{children}</div>
  </div>
);
